import { split } from "./fable_modules/fable-library-js.4.17.0/String.js";
import { item } from "./fable_modules/fable-library-js.4.17.0/Array.js";

export function validateEmail(x) {
    const l = x.length > 5;
    const at = x.indexOf("@") >= 0;
    const dot = x.indexOf(".") >= 0;
    const splitted = split(x, ["@"], undefined, 0);
    if (splitted.length > 1) {
        if (((((l && at) && dot) && (item(1, splitted).length > 2)) && (item(0, splitted).length > 0)) && (item(1, splitted).indexOf(".") >= 0)) {
            return !(((x.indexOf(",") >= 0) ? true : (x.indexOf("\'") >= 0)) ? true : (x.indexOf("\\") >= 0));
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

export function tryFocusInput(inputId) {
    try {
        window.document.getElementById(inputId).focus();
    }
    catch (matchValue) {
    }
}

